import React, { useEffect } from 'react';
import { MenuItem } from '@mui/material';
import { HookFormSelect } from '../common/components';

export default function ReferralProviderOptions({ prefix = null, control, errors, providers, schema, setValue, watch }) {
  const fieldName = prefix ? `${prefix}.${schema}` : schema;
  const selectedValue = watch(fieldName);

  useEffect(() => {
    if (providers?.length > 0 && !selectedValue) {
      setValue(fieldName, providers[0].id);
    }
  }, [providers, selectedValue, fieldName, setValue]);

  return (
    <HookFormSelect
      id={schema}
      type="select"
      select
      name={fieldName}
      placeholder={schema}
      label="Referrer Provider *"
      schema={schema}
      prefix={prefix}
      control={control}
      errors={errors}
      fullWidth
    >
      {providers &&
        providers.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.display_name}
          </MenuItem>
        ))}
    </HookFormSelect>
  );
}
